// [목적] 외부에서 온 이미지 URL 을 CSS `background` 의 `url(...)` 로 안전하게 만든다.
// [이유] `url(${value})` 처럼 값을 그대로 보간하면 `)` `;` `}` 를 포함한 값이 emotion 이 만든 CSS 선언 블록을 탈출할 수 있다
//        (보안 리뷰 2026-09-20 Low-1). 축제 이미지는 TourAPI 원본이라 위험은 낮지만, 이 저장소가 이미 같은 패턴을
//        `<img src>` 전환 / http(s) 스킴 가드로 막아 온 선례(SettingsSubPages, PlanItemEnrichedContent)와 맞춘다.
// [사이드 이팩트] http(s) 가 아닌 값(javascript:, data:, 상대경로 등)과 빈 값은 null 을 돌려준다 — 호출측은 폴백 배경을 쓴다.
//                 따옴표·괄호·역슬래시·공백은 퍼센트 인코딩되어 URL 의미는 유지된 채 CSS 문자열 밖으로 나갈 수 없다.
// [수정 시 고려사항] 프로토콜 상대 URL(//host)을 허용하려면 스킴 정규식을 함께 갱신할 것.

const HTTP_URL = /^https?:\/\//i;
const UNSAFE_IN_CSS_URL = /[\s"'()\\]/g;

export function safeCssUrl(raw: string | null | undefined): string | null {
  if (!raw || !HTTP_URL.test(raw)) return null;
  const escaped = raw.replace(
    UNSAFE_IN_CSS_URL,
    (ch) => `%${ch.charCodeAt(0).toString(16).toUpperCase().padStart(2, '0')}`,
  );
  return `url("${escaped}")`;
}
